import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Col, message, Row, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ContentWrapper, StyldDivider } from '../styled';
import {
  StyledImg,
  Title,
  Description,
  Label,
  ButtonContainer,
  UploadText,
  UploadHint,
  StyledLink
} from './styled';
import img_ns_scanning from '../../../../assets/img_ns_scanning.png';
import {
  showScanningPopup,
  showScreeningPopup,
  scanUploadedFile,
  setUploadedFile
} from '../../../../redux/actions/ns/onDemandScreening';
import ScanModal from './ScanModal';
import ScreenModal from './ScreenModal';
import {
  BULK_SCANNING_FLOW,
  BULK_SCREENING_FLOW
} from '../../../constants/nsConstants';
import { keys } from 'lodash';
import { downloadTemplate } from '../../../../services/ns/onDemandScreening';

const { Dragger } = Upload;
const FILE_SIZE = 25;

const BulkUpload = ({
  history,
  dispatch,
  onTabChange,
  bulkScreeningStarted,
  isShowScanModal,
  isShowScreenModal,
  currentScreeningState,
  uploadedFile
}) => {
  const props = {
    maxCount: 1,
    onRemove: (file) => {
      dispatch(setUploadedFile(null));
    },
    beforeUpload: (file) => {
      const fileSize = file.size / 1024 / 1024; //calculating in MB's

      if (file.type !== 'text/csv') {
        message.error(`"${file.name}" is not a CSV file`);
        return Upload.LIST_IGNORE;
      }

      if (fileSize > FILE_SIZE) {
        message.error(`Maximum file size allowed is 25 MB`);
        return Upload.LIST_IGNORE;
      }

      dispatch(setUploadedFile(file));

      return false;
    },
    fileList: uploadedFile ? [uploadedFile] : []
  };

  const onClickProceed = () => {
    if (bulkScreeningStarted) {
      if (keys(BULK_SCANNING_FLOW).includes(currentScreeningState)) {
        dispatch(showScanningPopup(true));
      } else if (keys(BULK_SCREENING_FLOW).includes(currentScreeningState)) {
        dispatch(showScreeningPopup(true));
      } else {
        message.error('Something went wrong pls refresh the screen');
      }
    } else if (uploadedFile) {
      const file = new FormData();

      file.append('file', uploadedFile);
      dispatch(scanUploadedFile({ file }));
    }
  };

  return (
    <ContentWrapper>
      <Row gutter={[48, 8]}>
        <Col span={5} offset={4}>
          <StyledImg src={img_ns_scanning} />
        </Col>
        <Col span={8}>
          <Title>Bulk Upload Customer List</Title>
          <Description>upload files upto {FILE_SIZE} MB</Description>
          <StyledLink onClick={downloadTemplate}>Download Sample</StyledLink>
          <Label>File Attachment</Label>
          <div>
            <Dragger {...props} disabled={bulkScreeningStarted}>
              <p>
                <PlusOutlined />
              </p>
              <UploadText>Click or drag file to this area to upload</UploadText>
              <UploadHint>Only one CSV file can be uploaded at once</UploadHint>
            </Dragger>
          </div>
          <ButtonContainer className="on-demand-screening-button-css">
            <Button
              type="primary"
              disabled={!uploadedFile}
              onClick={onClickProceed}>
              {bulkScreeningStarted
                ? 'Validation in progress'
                : 'Proceed to file validation'}
            </Button>
          </ButtonContainer>
        </Col>
      </Row>
      <StyldDivider />
      <Row>
        <Col span={8} offset={9}>
          <Description>
            Please note that single name scans cannot be performed while a bulk
            upload is being validated.
          </Description>
        </Col>
      </Row>
      {isShowScanModal && <ScanModal />}
      {isShowScreenModal && (
        <ScreenModal history={history} onTabChange={onTabChange} />
      )}
    </ContentWrapper>
  );
};

BulkUpload.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
  bulkScreeningStarted: PropTypes.bool,
  isShowScanModal: PropTypes.bool,
  isShowScreenModal: PropTypes.bool,
  currentScreeningState: PropTypes.string,
  history: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
  const {
    bulkScreening: {
      bulkScreeningStarted,
      isShowScanModal,
      isShowScreenModal,
      currentScreeningState,
      uploadedFile
    }
  } = state.nsOnDemandScreening;
  return {
    bulkScreeningStarted,
    isShowScanModal,
    isShowScreenModal,
    currentScreeningState,
    uploadedFile
  };
};

export default connect(mapStateToProps)(BulkUpload);
